import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  getEnabledOptions,
  getStoreValueByProp,
  getViewBySelection,
} from '../../store/createNewCarrierAuthSlice';
import SummaryStep from './Summary';

const mapState = R.applySpec({
  areAllCustomersAllowed: getStoreValueByProp(['areAllCustomersAllowed']),
  authorizationBy: getStoreValueByProp(['authorizationBy']),
  enabledOptions: getEnabledOptions,
  selectedCustomers: getStoreValueByProp(['selectedCustomers']),
  supplier: getStoreValueByProp(['supplier']),
  viewBySelection: getViewBySelection,
});

export default connect(mapState)(SummaryStep);
